import axios from "axios";
const baseUrl = "c-order-customer";
export default {
  getOrdersById(id) {
    return axios.get(baseUrl + `/order?id=${id}`);
  },
  getReviewById(id) {
    return axios.get(baseUrl + `/${id}/review`);
  },
  saveReview(data) {
    return axios.post(baseUrl + "/review", data);
  },
  cancel(data) {
    return axios.post(baseUrl + `/cancel`, data);
  },
  export(data) {
    return axios.post(baseUrl + `/export`, data, {
      responseType: "arraybuffer",
    });
  },
  beforeApproved(data){
    return axios.post(baseUrl + `/before-appoved`, data);
  },
  getMap(id) {
    return axios.get(baseUrl + `/map?order_customer_id=${id}`);
  },
};
